import type { ParagraphBlock } from '../types/report'
import { renderMarkdown } from './markdown'
import styles from './blocks.module.css'

export function Paragraph({ block }: { block: ParagraphBlock }) {
  return <div className={styles.paragraph}>{renderMarkdown(block.text)}</div>
}
